import { render, staticRenderFns } from "./AdminAttributesComponent.vue?vue&type=template&id=15298389"
import script from "./AdminAttributesComponent.vue?vue&type=script&lang=js"
export * from "./AdminAttributesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports